import React, { useState } from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Drawer,
  Tooltip,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo.tsx';
import MobileDrawer from './MobileDrawer.tsx';
import DesktopNav from './DesktopNav.tsx';
import ContactMenu from './ContactMenu.tsx';

const email = '5starlaundromatnc@gmail.com';
const phone = '+1 (336) 624-5244';

const ResponsiveAppBar: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorElServices, setAnchorElServices] = useState<HTMLButtonElement | null>(null);
  const theme = useTheme();
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  const handleNavigate = (route: string) => {
    navigate(route);
    setMobileOpen(false);
  };

  const handleServicesClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElServices(event.currentTarget);
  };

  const handleServicesClose = () => {
    setAnchorElServices(null);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        position="fixed"
        sx={{
          background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.background.default})`,
          zIndex: 1100,
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
            <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center' }}>
              <Logo onClick={() => handleNavigate('/')} height={82} />
            </Box>
          </Box>
          {/* Center Logo for Mobile */}
          <Box
            sx={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              display: { xs: 'flex', sm: 'none' },
            }}
          >
            <Logo onClick={() => handleNavigate('/')} height={50} />
          </Box>
          <DesktopNav
            onNavigate={handleNavigate}
            onServicesClick={handleServicesClick}
            anchorElServices={anchorElServices}
            onServicesClose={handleServicesClose}
          />
          <Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center' }}>
            <ContactMenu type="email" value={email} Icon={<EmailIcon />} />
            <ContactMenu type="phone" value={phone} Icon={<PhoneIcon />} />
            <Tooltip title="Contact Us">
              <IconButton onClick={() => handleNavigate('/contact-us')}>
                <ContactMailIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
        }}
      >
        <MobileDrawer onClose={handleDrawerToggle} onNavigate={handleNavigate} />
      </Drawer>
    </Box>
  );
};

export default ResponsiveAppBar;
